import { EntityType } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import { accountIdFromResolvedEntity } from '@frontend/components/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { ModuleExtendedClient } from '@frontend/module/api';
import { ModuleExtended } from '@frontend/module/types';
import { FormattedMessage } from 'react-intl';

import { usePlatformModalHost } from '../../../modal/platform-modal-host/platform-modal-host.context';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import OverviewHeader from '../../header/overview-header';
import { useModules } from './modules.controller';

export const Modules = () => {
    const viewProps = useModules();
    const { openPlatformDetail } = usePlatformModalHost();
    return (
        <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>
            <OverviewHeader
                title={
                    <div className='flex gap-2'>
                        <span>{CommonMessage.OBJECTS.SPOT.DISTRI_SPOTS}</span>
                        <span>/</span>
                        <span>{CommonMessage.OBJECTS.MODULE.PLURAL}</span>
                    </div>
                }
            />

            <ReactiveObjectList<ModuleExtended>
                key='modules-list'
                id={'modules-list'}
                fetch={(arg) => ModuleExtendedClient.fetchModuleExtendeds(arg)}
                dispatch={viewProps.dispatch}
                onSelectElement={(obj) =>
                    openPlatformDetail({
                        entityType: EntityType.MODULE,
                        id: obj.id,
                        parents: {
                            ...(obj.spot?.entity_id && { spot_id: obj.spot.entity_id })
                        }
                    })
                }
                type={EntityType.MODULE}
                columns={{
                    columns: ['spot', 'name', 'type'],
                    customCells: new Map([
                        [
                            'spot',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    <PlatformObjectBadge
                                        id={obj.row.original.spot?.entity_id}
                                        entityType={EntityType.SPOT}
                                        display={obj.row.original.spot?.name}
                                        key={obj.row.original.spot?.entity_id}
                                        foreign={obj.row.original.spot?.foreign}
                                        accountId={accountIdFromResolvedEntity(obj.row.original.spot)}
                                    />
                                </td>
                            )
                        ],
                        [
                            'type',
                            (obj) => (
                                <td className={defaultCellClassName}>
                                    {obj.row.original.type && (
                                        <DefaultBadge
                                            label={(obj.row.original.type.charAt(0).toUpperCase() + obj.row.original.type.slice(1)).replace(/_/g, ' ')}
                                            styles={{
                                                container: {
                                                    color: 'bg-brand-muted'
                                                }
                                            }}
                                        />
                                    )}
                                </td>
                            )
                        ]
                    ]),
                    headerOverwrite: new Map([
                        ['spot', CommonMessage.OBJECTS.SPOT.DISTRI_SPOT],
                        [
                            'name',
                            <FormattedMessage
                                defaultMessage='Module name'
                                id='spots.modules.module-name-header'
                                key='spots.modules.module-name-header'
                            />
                        ]
                    ])
                }}
                activeFilter={{ searchKeys: ['spot'], filterKeys: ['spot_id'], displayName: new Map([['spot', CommonMessage.OBJECTS.SPOT.DISTRI_SPOT]]) }}
            />
        </div>
    );
};
